// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"24":"cab97c0f","380":"b0a698ac","506":"e52dd678"}[chunkId] + ".css";
};